import axios from "axios";
import qs from "qs";
import { BASE_URL } from "./endpoint";

export const fetchCsrfToken = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/manage-account/csrf-token`);
    const csrfToken = response.headers["x-csrf-token"];
    return csrfToken
  } catch (e) {
    // Optionally handle error
   getErrorMessage(e)
  
  }
};

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  // timeout: 20000,
});

axiosInstance.interceptors.response.use(
  (response) => {
    // Hide spinner after successful API response
    // But skip on report pages, lift tool page, correction request page, and nmvtis pages
    // These pages handle spinner visibility themselves
    const isReportPage = window.location.pathname.includes('/report/') || 
                        window.location.pathname.includes('/report') ||
                        window.location.pathname.includes('/fullreport') ||
                        window.location.pathname.includes('/summaryreport') ||
                        window.location.pathname.includes('/scanreport') ||
                        window.location.pathname.includes('/accidentreport');
    const isLiftToolPage = window.location.pathname.includes('/uploadLiftTool') ||
                           window.location.pathname.includes('/liftTool') ||
                           window.location.pathname.includes('/upload-lift-tool') ||
                           window.location.pathname.includes('/upload-lifttool-file');
    const isCorrectionRequestPage = window.location.pathname.includes('/correction-request') ||
                                    window.location.pathname.includes('/correctionRequest');
    const isReferFriendPage = window.location.pathname.includes('/refer-friend') ||
                              window.location.pathname.includes('/referFriend');
    const isElitePage = window.location.pathname.includes('/eliteReports') ||
                       window.location.pathname.includes('/elite-reports') ||
                       window.location.pathname === '/eliteReports' ||
                       window.location.pathname.startsWith('/eliteReports');
    const isNmvtisPage = window.location.pathname.includes('/nmvtisreport') ||
                        window.location.pathname.includes('/nmvtis-report') ||
                        window.location.pathname.includes('/nmvtisReports') ||
                        window.location.pathname.includes('/nmvtis-reports');
    
    // Only hide spinner if not on pages that handle it themselves
    if (!isReportPage && !isLiftToolPage && !isCorrectionRequestPage && !isReferFriendPage && !isElitePage && !isNmvtisPage) {
      const spinner = document.getElementById("spinner");
      const body = document.body;
      if (spinner && body) {
        spinner.style.visibility = "hidden";
        spinner.style.display = "none";
        body.style.opacity = "1";
        body.style.transition = "";
        body.classList.remove("spinner-active");
      }
    }
    return response;
  },
  (error) => {
    // Hide spinner on error - but skip on report pages, lift tool page, and correction request page to prevent navbar shaking
    const isReportPage = window.location.pathname.includes('/report/') || 
                        window.location.pathname.includes('/report') ||
                        window.location.pathname.includes('/fullreport') ||
                        window.location.pathname.includes('/summaryreport') ||
                        window.location.pathname.includes('/scanreport') ||
                        window.location.pathname.includes('/accidentreport');
    const isLiftToolPage = window.location.pathname.includes('/uploadLiftTool') ||
                           window.location.pathname.includes('/liftTool') ||
                           window.location.pathname.includes('/upload-lift-tool') ||
                           window.location.pathname.includes('/upload-lifttool-file');
    const isCorrectionRequestPage = window.location.pathname.includes('/correction-request') ||
                                    window.location.pathname.includes('/correctionRequest');
    const isReferFriendPage = window.location.pathname.includes('/refer-friend') ||
                              window.location.pathname.includes('/referFriend');
    const isElitePage = window.location.pathname.includes('/eliteReports') ||
                       window.location.pathname.includes('/elite-reports') ||
                       window.location.pathname === '/eliteReports' ||
                       window.location.pathname.startsWith('/eliteReports');
    const isNmvtisPage = window.location.pathname.includes('/nmvtisreport') ||
                        window.location.pathname.includes('/nmvtis-report') ||
                        window.location.pathname.includes('/nmvtisReports') ||
                        window.location.pathname.includes('/nmvtis-reports');
    
    // Hide spinner on error for all pages except report pages, lift tool, correction request, refer friend, elite, and nmvtis
    // nmvtis page should have spinner hidden by component, not interceptor
    if (!isReportPage && !isLiftToolPage && !isCorrectionRequestPage && !isReferFriendPage && !isElitePage && !isNmvtisPage) {
      const spinner = document.getElementById("spinner");
      const body = document.body;
      if (spinner && body) {
        spinner.style.visibility = "hidden";
        spinner.style.display = "none";
        // Only reset body opacity if it was actually set
        if (body.style.opacity && body.style.opacity !== "1") {
          body.style.opacity = "1";
          body.style.transition = "";
        }
      }
    }
    
    if (error.response) {
      const status = error.response.status;
      if (status === 500) {
        throw new Error("Internal Server Error");
      }
    }

    return Promise.reject(error);
  }
);

axiosInstance.interceptors.request.use(async (config) => {
  const token = localStorage.getItem("membersite_token");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  if (config.data instanceof FormData) {
    config.headers["Content-Type"] = "multipart/form-data";
  }
  try {
    if (config.method !== "get")
        config.headers["X-CSRF-TOKEN"] = await fetchCsrfToken();
    } catch (error) {
      return Promise.reject(error);
    }
  
  // Show spinner for API requests (like jQuery ajaxStart in legacy)
  // Legacy behavior: spinner shows for ALL AJAX requests except specific excluded pages
  // Spinner should show for: search pages, file upload pages (except lift tool)
  // Spinner should NOT show for: report pages, dashboard, lift tool, correction request, refer friend
  const skipSpinnerEndpoints = [
    '/csrf-token', 
    '/manage-account/csrf-token',
    '/manage-account/login',
    '/manage-account/nmvtis-login',
    '/manage-account/login-scripter',
    '/manage-account/token-extract',
    '/manage-account/roi-calculator', // ROI calculator handles its own spinner
    '/upload-lift-tool-file',
    'dealers/group-details',
    'dealers/details',
    '/correctionRequest',
    '/refer-friend'
  ];
  const isReportPage = window.location.pathname.includes('/report/') || 
                       window.location.pathname.includes('/report') ||
                       window.location.pathname.includes('/fullreport') ||
                       window.location.pathname.includes('/summaryreport') ||
                       window.location.pathname.includes('/scanreport') ||
                       window.location.pathname.includes('/accidentreport');
  const isDashboardPage = window.location.pathname.includes('/dashboard');
  const isLiftToolPage = window.location.pathname.includes('/uploadLiftTool') ||
                         window.location.pathname.includes('/liftTool') ||
                         window.location.pathname.includes('/upload-lift-tool') ||
                         window.location.pathname.includes('/upload-lifttool-file');
  const isCorrectionRequestPage = window.location.pathname.includes('/correction-request') ||
                                  window.location.pathname.includes('/correctionRequest');
  const isReferFriendPage = window.location.pathname.includes('/refer-friend') ||
                            window.location.pathname.includes('/referFriend');
  const isElitePage = window.location.pathname.includes('/eliteReports') ||
                      window.location.pathname.includes('/elite-reports') ||
                      window.location.pathname === '/eliteReports' ||
                      window.location.pathname.startsWith('/eliteReports');
  const isNmvtisPage = window.location.pathname.includes('/nmvtisreport') ||
                       window.location.pathname.includes('/nmvtis-report') ||
                       window.location.pathname.includes('/nmvtisReports') ||
                       window.location.pathname.includes('/nmvtis-reports');
  // Show spinner for search and file upload pages (matching legacy ajaxStart behavior)
  // Only skip spinner for specific excluded pages
  // Note: nmvtis page needs spinner but it will be handled by the component
  const shouldShowSpinner = !skipSpinnerEndpoints.some(endpoint => config.url?.includes(endpoint)) && 
                           !isReportPage && 
                           !isDashboardPage &&
                           !isLiftToolPage &&
                           !isCorrectionRequestPage &&
                           !isReferFriendPage &&
                           !isElitePage;
  
  if (shouldShowSpinner) {
    const spinner = document.getElementById("spinner");
    const body = document.body;
    if (spinner && body) {
      body.style.opacity = "0.8";
      body.style.transition = "opacity 0s";
      spinner.style.visibility = "visible";
      spinner.style.display = "block";
      spinner.style.opacity = "1";
      
      // Ensure text spans are visible (matches legacy structure)
      const spans = spinner.querySelectorAll("span");
      spans.forEach((span) => {
        span.style.visibility = "visible";
        span.style.opacity = "1";
        span.style.color = "black";
        span.style.display = "inline-block";
      });
    }
  }
  
  return config;
});

export const apiService = async (
  method,
  endpoint,
  data,
  options,
  onSuccess,
  onError
) => {
  try {
    if (options.urlEncoded) {
      data = qs.stringify(data);
      options.headers = {
        ...(options.headers || {}),
        "Content-Type": "application/x-www-form-urlencoded",
      };
    }

    const response = await axiosInstance.request({
      method,
      url: endpoint,
      ...options,
      data: data,
    });
    onSuccess?.(response.data);
    return response.data;
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    onError?.(errorMessage);
    return { success: false, error: errorMessage };
  }
};

const getErrorMessage = (error) => {
  const status = error.response?.status;
  const serverErrors = error.response?.data?.errors || error.response?.data?.data;
  const serverMessage = error.response?.data?.details;
  switch (status) {
    case 400:
      return serverErrors || "Bad Request – Please check your input.";
    case 401:
      return serverMessage || "Token Validation Failed...";
    case 403:
      window.location.href = '/members/forbidden';
      return false;
    case 404:
      return "Not Found – The requested resource doesn't exist.";
    case 500:
      return "Internal Server Error – Please try again later.";
    case 422:
      return serverErrors || "Report Service or Other Service not responding..";
    default:
      return serverMessage || "An unexpected error occurred.";
  }
};

let lastActivityTime = Date.now();

// Update activity time on user interaction
export const updateLastActivity = () => {
  lastActivityTime = Date.now();
};

export const checkTokenExpiryAndLogout = () => {
  const token = localStorage.getItem("membersite_token");
  if (!token) return;
  
  try {
    // Check JWT token expiry
    const payload = JSON.parse(atob(token.split('.')[1]));
    const exp = payload.exp;
    
    if (exp && Date.now() / 1000 > exp) {
      // Token expired, clear storage and redirect to login
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/members/login.do";
      return;
    }
    
    // Check idle timeout (30 minutes = 1800000 ms)
    const idleTimeoutMs = 30 * 60 * 1000;
    if (Date.now() - lastActivityTime > idleTimeoutMs) {
      // User has been idle too long, logout
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/members/login.do";
      return;
    }
  } catch (e) {
    // Invalid token, logout for safety
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/members/login.do";
  }
};

// Initialize activity tracking
export const initializeActivityTracking = () => {
  const events = [
    'mousedown',
    'mousemove', 
    'keypress',
    'scroll',
    'touchstart',
    'click'
  ];

  events.forEach(event => {
    window.addEventListener(event, updateLastActivity, true);
  });

  // Check for timeout every 5 minute
  setInterval(checkTokenExpiryAndLogout, 300000);
};
